/**
 * New typescript file
 */
import { CacheService } from '../../../../../services/sys/cache.service';
import { CmnUiService } from '../../../../../services/ui/cmn-ui.service';
import { LocaleService } from '../../../../../services/ui/locale.service';
import { Component, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { EventEmitter } from '@angular/core';
import {SubscriptionLike as ISubscription} from 'rxjs';
import { FieldMap } from './../../../../interfaces/fieldMap.interface';

declare var jQuery: any;

@Component({
    selector: 'gd-field-inputtext',
    templateUrl: 'gd-field-inputtext.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GdFieldInputtextComponent {

    @Input() gdFieldId: string;
    
    @Input() gdModel: string;
    
    @Output() gdModelChange: EventEmitter<string> = new EventEmitter<string>();
    
    @Output() gdFocus: EventEmitter<void> = new EventEmitter<void>();
  
    @Output() gdKeyDownTab: EventEmitter<any> = new EventEmitter<any>();
    
    @Input() gdShowFlag: boolean = true;
    
    @Input() gdDisableHook: string;
    
    @Input() gdLabel:    string;
    
    @Input() gdAddClass: string;
    
    @Input() gdDisabled: boolean = false;
    
    @Input() gdHideLabel: string;
    
    @Input() gdErrorImgAlt: string;
    
    @Input() gdMaxLength: number;
    
    @Input() gdPlaceholder: any = "";
    
    @Input() fieldMap: FieldMap;
    
    @Input() gdShowVirtualKeyboard: boolean = false;
  
    @Input() gdShowLabel: boolean = true;
	
	@Input() gdLabelA: string;
	
	@Input() gdLabelB: string;
	
	@Input() gdLabelC: string;
	
	
	//link to external link in label
	@Input() gdShowLabelExternalLink: boolean = false;
	
	@Input() gdLabelExternalLink: string;
    
    //OK confirm web link
    @Input() confirmWebIndex: string;
    @Output() updateConfirmWeb: EventEmitter<any> = new EventEmitter<any>();

    virtualKeyboardLabelString: string;

    constructor(private cacheService: CacheService,
                private localeService: LocaleService,
                private cmnUiService: CmnUiService) {
        
    }
  
    ngOnInit() {
    	const localeStr = this.localeService.getLocaleStr();
        if(localeStr && localeStr === 'es_ES') {
            this.virtualKeyboardLabelString = ' Teclado virtual';
        } else {
            this.virtualKeyboardLabelString = ' Virtual keyboard';
        }
	}
    
    ngAfterViewInit() {
       if (this.gdShowVirtualKeyboard == true) {
            this.cmnUiService.placeSvgCode(".virtualKeyboard");
        } 
    }
  
    ngOnDestroy() {

    }
    
    outputGdModel() {
        this.gdModelChange.emit(this.gdModel);
    }
    
    onFocus(event): void {
        setTimeout(() => {
          jQuery("body").stop().animate({
                scrollTop: jQuery(event.target).offset().top
          }, 1000);
        }, 0);
        this.gdFocus.next();
    }
  
    onKeyDown(event): void {
        const eventKeyCode = event.keyCode || event.which;
        if(!event.shiftKey && eventKeyCode == 9){
          this.gdKeyDownTab.emit();
        }
    }
    /*
     * This is simply and event handler for when input occurs on the text input. If you look at the input element,
     * you will notice that we are using the input event. This event has pretty good browser support and catches input
     * changes like keypress, copy and paste and drag and drop.
     */
    onInputHandler(event): void {
        /* 
         * This is needed to both perform the character replacement function,
         * and update the ngModel to the new value such that validation will
         * run against the edited field value.
         */
        this.gdModel = this.cmnUiService.preventSmartPunctuation(event.target.value);
        //This is needed to update the DOM input value with the edited field value
        event.target.value = this.gdModel;
        this.outputGdModel();
    }
    
    //emit OK click event
    confirmWeb(confirmationFieldId){
        this.updateConfirmWeb.emit(this.confirmWebIndex);
		jQuery("#" + confirmationFieldId).focus();
    };

    updateVirtualKeyboardOnViewportChange(viewportFlag): void {
        if(viewportFlag == 'desktop') {
            setTimeout(() => {
                this.cmnUiService.placeSvgCode('.virtualKeyboard');
            }, 0);
        }
    }
}
